// Author NYA
// Date 2020-11-10 11:33:21

import * as model from "@/model/sithMes/prd/SithMesPrdStopWorkTypeModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {levelTreePatternFactory} from "@/store/em/commonPattern/levelTreePatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesPrdStopWorkType(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_PRD_URL,
    })
    .withPatternFactory(levelTreePatternFactory, {
        entity: 'sithMesPrdStopWorkType',
        modelFilter: model.filter
    })
    .buildStore()
